import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'app/app-config.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CsrfTokenService {
    constructor(private _httpClient: HttpClient, private configService: AppConfigService) { }


    async fetchCsrfToken(): Promise<void> {
        try {
            const url = `${this.configService.getConfiguration().apiUrl}/antiforgery/token`;
            await lastValueFrom(this._httpClient.get(url, { withCredentials: true }));
            console.log('CSRF token initialized.');
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
        }
    }


}
